import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { neutral } from '../../../style/colors';

const SidebarButton = (props: ISidebarButtonPropTypes) => {
  const {
    text,
    icon,
    onClick,
    color,
    backgroundColor,
    borderBottom,
    width,
    marginLeft,
    marginTop,
  } = props;
  const buttonRef = useRef<HTMLButtonElement>();
  const blur = () => {
    const node = buttonRef.current;
    if (node) {
      node.blur();
    }
  };
  const renderIcon = icon ? (
    <ButtonIconContainer>{icon}</ButtonIconContainer>
  ) : null;
  return (
    <Wrapper
      ref={buttonRef}
      onClick={onClick}
      onMouseUp={blur}
      backgroundColor={backgroundColor}
      borderBottom={borderBottom}
      width={width}
      marginLeft={marginLeft}
      marginTop={marginTop}
    >
      {renderIcon}
      <ButtonText color={color}>{text}</ButtonText>
    </Wrapper>
  );
};

const Wrapper = styled.button`
  margin: 30px 0 40px 32px;
  ${props =>
    props.marginLeft &&
    css`
      margin-left: ${props.marginLeft};
    `}
  ${props =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}
  width: 366px;
  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${neutral[600]};
  ${props =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `}
  border: none;
  border-bottom: solid 3px #2e4b6a;
  ${props =>
    props.borderBottom &&
    css`
      border-bottom: ${props.borderBottom};
    `}
  cursor: pointer;
  :focus {
    outline: 0;
    box-shadow: unset;
  }
`;
const ButtonIconContainer = styled.div`
  padding-top: 2px;
  margin-right: 5px;
`;

const ButtonText = styled.span`
  margin-left: 5px;
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `}
`;

interface ISidebarButtonPropTypes {
  onClick: Function;
  text: string;
  icon?: any;
  color?: string;
  backgroundColor?: string;
  borderBottom?: string;
  width?: string;
  marginLeft?: string;
  marginTop?: string;
}

export default SidebarButton;
